import crown from '../assets/crown-gold.svg';

const Loading = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      width: '100%',
    }}
         className="animate-pulse"
    >
      <img src={crown} alt="Rolex Crown" width={60} height={60}
           className="w-[60px] h-[60px]"/>
      <p class="mt-2">Laden</p>
    </div>
  )
};

export default Loading;
